import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { AlertMessagePayload } from '../../service/alert.service';
import { PasswordAlertService } from '../../service/password-alert.service';
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-password-alert-message',
  standalone: true,
  templateUrl: './password-alert-message.component.html',
  styleUrl: './password-alert-message.component.css',
  imports: [CommonModule, MatIconModule, MatButtonModule, FormsModule]
})
export class PasswordAlertMessageComponent implements OnInit, OnDestroy {

  private subscription!: Subscription;
  private langChangeSubscription!: Subscription;
  message: AlertMessagePayload | null | undefined;
  renderedText: string = '';
  private timeoutId: any;

  @Input() iconStyle: { [key: string]: any } = {};

  constructor(
    private passwordAlertService: PasswordAlertService,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.subscription = this.passwordAlertService.getMessage().subscribe(message => {
      this.message = message;
      this.refreshRenderedText();
      this.cdr.detectChanges();
    });

    this.langChangeSubscription = this.translate.onLangChange.subscribe(() => {
      if (!this.message) {
        return;
      }

      this.refreshRenderedText();
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.langChangeSubscription?.unsubscribe();
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  close() {
    this.passwordAlertService.clear();
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  private refreshRenderedText(): void {
    if (!this.message) {
      this.renderedText = '';
      return;
    }

    if (this.message.i18nKey) {
      this.renderedText = this.translate.instant(this.message.i18nKey, this.message.i18nParams);
      return;
    }

    this.renderedText = this.message.text ?? '';
  }

}
